import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enLayout from './locales/en/layout.json';
import enNotifications from './locales/en/notifications.json';
import enPages from './locales/en/pages.json';
import ruCommon from './locales/ru/common.json';
import ruLayout from './locales/ru/layout.json';
import ruNotifications from './locales/ru/notifications.json';
import ruPages from './locales/ru/pages.json';

export const resources = {
  en: {
    common: enCommon,
    layout: enLayout,
    notifications: enNotifications,
    pages: enPages,
  },
  ru: {
    common: ruCommon,
    layout: ruLayout,
    notifications: ruNotifications,
    pages: ruPages,
  },
} as const;

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru'],
    defaultNS: 'common',
    ns: ['common', 'layout', 'notifications', 'pages'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });
}

export default i18n;
